import React from 'react';
import DismissableFeedback from "./common/DismissableFeedback";
import log from 'loglevel';


class ErrorBoundary extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // TODO: Register the error to external monitoring tool
    //logErrorToMyService(error, errorInfo);
    log.error({ error, errorInfo });
  }

  render() {
    
	  
	if (this.state.hasError) {
      return <DismissableFeedback translate={true} feedback={'error.boundary.general'} type="danger" />
    }

    return this.props.children; 
  }
}


export default ErrorBoundary;